
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-custom.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-custom-demo-custom"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-custom.zh-CN.md?type=demo')
};